const func = $target => {
	window.loader.key('swiper', function() {
		if ($target.find('.swiper-slide').length > 1) {
			var quotes011 = new Swiper($target.find('.quotes'), {
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: {
					nextEl: $target.find('.swiper-button-next'),
					prevEl: $target.find('.swiper-button-prev')
				},
				on: {
					init: function() {
						$('[data-kd-id="011"] .quotes').addClass('show');
					}
				}
			});
		}
	});
};

export default func;
